import axios from "axios";
import config from "../config";
import { toast } from "react-toastify";

// تابع ساخت و نمایش مدال سفارشی قطعی اینترنت
function showConnectionModal() {
  if (document.getElementById("network-error-modal")) return;

  const modalHtml = `
    <div id="network-error-modal" style="
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background-color: rgba(0, 0, 0, 0.65);
      backdrop-filter: blur(8px);
      -webkit-backdrop-filter: blur(8px);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 999999;
      direction: rtl;
      font-family: inherit;
    ">
      <div style="
        background: #ffffff;
        padding: 30px;
        border-radius: 16px;
        max-width: 420px;
        width: 90%;
        text-align: center;
        box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.15), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
        animation: modalScaleIn 0.3s ease-out-in;
        position: relative;
      ">
        <style>
          @keyframes modalScaleIn {
            0% { transform: scale(0.9); opacity: 0; }
            100% { transform: scale(1); opacity: 1; }
          }
          .network-reload-btn {
            background-color: #ef4444;
            color: white;
            border: none;
            padding: 12px 24px;
            font-size: 15px;
            font-weight: bold;
            border-radius: 8px;
            cursor: pointer;
            transition: all 0.2s ease;
            width: 100%;
            margin-top: 15px;
            box-shadow: 0 4px 6px -1px rgba(239, 68, 68, 0.3);
          }
          .network-reload-btn:hover {
            background-color: #dc2626;
            transform: translateY(-1px);
          }
          .network-close-btn {
            background-color: transparent;
            color: #6b7280;
            border: 1px solid #e5e7eb;
            padding: 10px 24px;
            font-size: 14px;
            border-radius: 8px;
            cursor: pointer;
            width: 100%;
            margin-top: 10px;
            transition: all 0.2s;
          }
          .network-close-btn:hover {
            background-color: #f3f4f6;
          }
        </style>

        <div style="font-size: 60px; margin-bottom: 15px; color: #ef4444;">
          ⚠️
        </div>
        
        <h3 style="margin: 0 0 12px 0; font-size: 18px; color: #1f2937; font-weight: 800;">
          خطا در ارتباط با سرور
        </h3>
        
        <p style="color: #6b7280; font-size: 14px; line-height: 1.6; margin: 0 0 20px 0;">
          ارتباط با سرور برقرار نشد. لطفاً وضعیت اینترنت یا فیلترشکن خود را بررسی کرده و مجدداً تلاش کنید.
        </p>

        <button class="network-reload-btn" onclick="window.location.reload()">
          تلاش مجدد و بارگذاری صفحه
        </button>
        <button class="network-close-btn" onclick="document.getElementById('network-error-modal').remove()">
          بستن پیام
        </button>
      </div>
    </div>
  `;

  const wrapper = document.createElement("div");
  wrapper.innerHTML = modalHtml;
  document.body.appendChild(wrapper.firstElementChild);
}

const api = axios.create({
  baseURL: config.api.baseURL,
  timeout: 20000, // تعیین مهلت 20 ثانیه برای جلوگیری از معلق ماندن ریکوئست‌ها
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

// ۱. آماده‌سازی درخواست
api.interceptors.request.use(
  (requestConfig) => {
    const token = localStorage.getItem("ACCESS_TOKEN");
    if (token) {
      requestConfig.headers.Authorization = `Bearer ${token}`;
    }
    return requestConfig;
  },
  (error) => Promise.reject(error)
);

// ۲. کنترل خطاها در زمان دریافت پاسخ
api.interceptors.response.use(
  (response) => {
    // بررسی انقضای توکن در بدنه دیتای بازگشتی
    if (response?.data?.is_expire === true) {
      console.warn("توکن نامعتبر یا منقضی شده است (از طریق دیتا)");
      localStorage.removeItem("ACCESS_TOKEN");
      localStorage.removeItem("USER_ID");
      localStorage.removeItem("isProfileComplete"); // اضافه شود

      window.dispatchEvent(new Event('profileUpdated')); // آپدیت هدر
      window.location.href = "/";
    }
    return response;
  },
  (error) => {
    // اگر درخواست عمداً لغو شده باشد (AbortController)
    if (axios.isCancel(error)) {
      return Promise.reject(error);
    }

    // بررسی خطای احراز هویت ($401$)
    if (error.response && error.response.status === 401) {
      console.warn("خطای 401: توکن نامعتبر یا منقضی شده است");
      localStorage.removeItem("ACCESS_TOKEN");
      localStorage.removeItem("USER_ID");
      localStorage.removeItem("isProfileComplete");

      window.dispatchEvent(new Event('profileUpdated')); // آپدیت هدر
      window.location.href = "/";
      return Promise.reject(error);
    }

    // خطاهای سروری ($500$ به بالا)
    if (error.response && error.response.status >= 500) {
      toast.error("خطای داخلی سرور رخ داده است. لطفاً بعداً تلاش کنید.");
      return Promise.reject(error);
    }

    // اگر خطای شبکه واقعی بود (ارتباط با سرور کلا برقرار نشد)
    if (!error.response || error.code === "ERR_NETWORK") {
      // تفکیک خطای تایم‌اوت از قطعی شبکه
      if (error.code === 'ECONNABORTED') {
        toast.error("سرور در زمان مقرر پاسخ نداد (Timeout).");
      } else {
        console.error("Network / CORS Error Object:", error); // برای بررسی در Console
        showConnectionModal();
      }
    }

    return Promise.reject(error);
  }
);

export default api;
